import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Icon, UilChartPie } from '@iconscout/react-unicons';
import { useAuth } from 'providers/AuthProvider';

export interface Route {
  name: string;
  icon?: IconProp | string | string[];
  iconSet?: 'font-awesome' | 'feather' | 'unicons';
  pages?: Route[];
  path?: string;
  pathName?: string;
  flat?: boolean;
  topNavIcon?: string;
  dropdownInside?: boolean;
  active?: boolean;
  new?: boolean;
  hasNew?: boolean;
  next?: boolean;
  nivel_acceso?: string[]; // Add access restriction
}

export interface RouteItems {
  label: string;
  horizontalNavLabel?: string;
  icon: Icon;
  labelDisabled?: boolean;
  pages: Route[];
  megaMenu?: boolean;
  active?: boolean;
}

const getRoutes = (nivel_acceso: string | null): RouteItems[] => {
  const baseRoutes: RouteItems[] = [
    {
      label: 'procesos',
      horizontalNavLabel: 'home',
      active: true,
      icon: UilChartPie,
      labelDisabled: true,
      pages: [
        {
          name: 'tablero',
          icon: 'clipboard',
          path: '/app/project-management',
          pathName: 'project-management-dashboard',
          active: true,
          nivel_acceso: ['socio'] // Everyone
        },
        {
          name: 'procesos',
          icon: 'list',
          path: '/app/apps/project-management/procesos-list-view',
          pathName: 'project-management-procesos-list-view',
          active: true,
          nivel_acceso: ['usuario', 'supervisor', 'LA', 'socio', 'pagos'] // Everyone
        },
        /*         {
          name: 'Movimientos Pendientes',
          icon: 'list',
          path: '/apps/project-management/pendientes-list-view',
          pathName: 'project-management-pendientes-list-view',
          active: true,
          nivel_acceso: [ 'supervisor', 'socio', 'pagos', 'usuario']
        },
 */     {
          name: 'Cobros Pendientes', // cada usuario ve sus pagos pendientes
          icon: 'clock',
          path: '/app/apps/project-management/cobros-list-view',
          pathName: 'project-management-cobros-list-view',
          active: true,
          nivel_acceso: ['supervisor', 'socio', 'LA', 'pagos', 'usuario']
        },
        {
          name: 'Pagos Generales', // solo paga FAM y Socios
          icon: 'dollar-sign',
          path: '/app/apps/pagos/pagos-generales-list-view',
          pathName: 'pagos-list-view',
          active: true,
          nivel_acceso: ['pagos']
        },
        {
          name: 'Caja',
          icon: 'dollar-sign',
          path: '/app/apps/project-management/caja-list-view',
          pathName: 'caja-list-view',
          active: true,
          nivel_acceso: ['usuario', 'LA', 'supervisor', 'socio', 'pagos']
        },
        {
          name: 'Miembros',
          icon: 'users',
          path: '/app/pages/members',
          pathName: 'members-page',
          active: true,
          nivel_acceso: ['usuario', 'LA', 'supervisor', 'socio', 'pagos']
       },
       {
          name: 'Archivos',
          icon: 'file',
          path: '/app/apps/file-manager/grid-view',
          pathName: 'grid-view',
          active: true,
          nivel_acceso: ['socio']
       },              
       {
        name: 'Whatsapp',
        icon: 'message-circle',
        path: '/app/apps/chat',
        pathName: 'chat',
        active: true,
        nivel_acceso: ['usuario', 'LA', 'supervisor', 'socio', 'pagos']
      },
      {
        name: 'Personas',
        icon: 'users',
        path: '/app/apps/crm/personas',
        pathName: 'personas',
        active: true,
        nivel_acceso: ['socio', 'usuario']
      },
      {
        name: 'Calendario',
        icon: 'calendar',
        path: '/app/apps/calendar',
        pathName: 'calendario',
        active: true,
        nivel_acceso: ['socio']
      },

    ]}]
  
  // Filter routes based on role
  return baseRoutes.map(route => ({
    ...route,
    pages: route.pages.filter(
      page =>
        page.nivel_acceso?.includes(nivel_acceso || 'user') ||
        !page.nivel_acceso
    )
  }));
};

export const RoutesComponent = () => {
  const { user } = useAuth();
  const routes = getRoutes(user?.nivel_acceso || null);
  console.log('Filtered routes for role', user?.nivel_acceso, ':', routes);
  // Use routes in your navigation bar here
  return null; // Replace with your nav rendering logic
};

export default getRoutes;
